$(document).ready(function(){
  if($('.product-form__cart-submit').attr('aria-disabled') == true) $('.shipping-badge').addClass('hide');
  else $('.shipping-badge').removeClass('hide');
  $('.product-form__cart-submit').on('click', function(){
    if(!$(this).attr('aria-disabled')){
      $('.AddToCartContainer .Cheering').addClass('Show');
    }
    setTimeout(function() {
      $('.AddToCartContainer .Cheering').removeClass('Show');
    }, 1500);
  });

  $('.us-title.block-title').each(function(){
    $(this).on('click', function(){
      if($(this).hasClass('active')){
        $('.us-title.block-title').removeClass('active');
      }else{
        $('.us-title.block-title').removeClass('active');
        $(this).addClass('active');
      }
    });
  });
  
  $('.icon-title').each(function(){
    $(this).on('click', function(){
      if($(this).hasClass('active')){
        $('.icon-title').removeClass('active');
      }else{
        $('.icon-title').removeClass('active');
        $(this).addClass('active');
      }
    });
  });
});